import { AdOrderStatusEnum } from '../enum';


export const adOrderStatusBadges: { [key in AdOrderStatusEnum]: { text: string; classes: string } } = {
  [AdOrderStatusEnum.DRAFT]: {
    text: 'Черновик',
    classes: 'mat-tooltip-trigger ml-4 bg-gray-100 text-gray-800 rounded-md px-2 py-1 text-xs',
  },
  [AdOrderStatusEnum.AWAITING_PAYMENT]: {
    text: 'Ожидает оплаты',
    classes: 'mat-tooltip-trigger ml-4 bg-yellow-100 text-yellow-800 rounded-md px-2 py-1 text-xs',
  },
  [AdOrderStatusEnum.IN_PROGRESS]: {
    text: 'Выполняется',
    classes: 'mat-tooltip-trigger ml-4 bg-blue-400 text-white rounded-md px-2 py-1 text-xs',
  },
  [AdOrderStatusEnum.COMPLETED]: {
    text: 'Выполнен',
    classes: 'mat-tooltip-trigger ml-4 bg-green-100 text-green-800 rounded-md px-2 py-1 text-xs',
  },
  [AdOrderStatusEnum.CANCELED]: {
    text: 'Отменен',
    classes: 'mat-tooltip-trigger ml-4 bg-red-400 text-white rounded-md px-2 py-1 text-xs',
  },
};
